import PostLoader from "@/ts/base/Components/PostLoader";
import EqualHeightPostCardCollection from "@/ts/base/Components/EqualHeightPostCardCollection";
import Main from "@/ts/base/Main";

class Blog {
	protected container: HTMLElement | null;
	protected postLoader!: PostLoader;

	constructor() {
		this.container = window.document.querySelector(".post-list");
		if (this.container instanceof HTMLElement) {
			this.postLoader = new PostLoader(this.container, "post");
			this.container.addEventListener(PostLoader.LoadSuccess, this.onPostsLoad.bind(this));

			Main.Instance.postLoaders?.add(this.postLoader);
		}
	}

	protected onPostsLoad(e: Event): void {
		new EqualHeightPostCardCollection(this.container, true);
	}
}

export default Blog;
